import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { InsuranceAuditView } from '../components/views/insuranceAuditView'
import { Page, PageHeader } from '../ui'

function InsuranceAudit() {
    return (
        <div className="insuranceAudit">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader
                        eyebrow="Sentinel Tools"
                        title="Insurance Audit"
                        intro="Clients allocated to the insurance audit, with their claims and contact details."
                    />
                    <InsuranceAuditView />
                </Page>
            </MainView>
        </div>
    )
}

export default InsuranceAudit
